declare var FB: any;
export function share(link) {
  FB.ui({
    method: 'share',
    href: link
  }, function(response){});
}



// WEBPACK FOOTER //
// ./src/actions/facebook.ts